/*
  "Pairs well with" on the product page (rr-pairs, Oct 2026): loads Shopify's
  complementary products into the box, then handles the quick-add stepper.
  Tracking (Shopify analytics custom events): complementary_product_viewed when
  the box scrolls into view, complementary_product_clicked on "View details",
  complementary_product_add_to_cart on Add. Adds are also written to the cart
  attribute rr_upsell_log as pairs_well_with:<variant> or xmas_pairs:<variant>.
*/
(function () {
  if (window.__rrPairsInstalled) return;
  window.__rrPairsInstalled = true;

  function closest(el, selector) {
    while (el && el !== document) {
      if (el.matches && el.matches(selector)) return el;
      el = el.parentNode;
    }
    return null;
  }

  function updateHeaderCount(count) {
    try {
      var nodes = document.querySelectorAll('[data-cart-count], [data-header-cart-count], .cart-count');
      for (var i = 0; i < nodes.length; i++) nodes[i].textContent = count;
    } catch (e) {
      /* cosmetic only */
    }
  }

  function showMessage(wrap, text, isError) {
    var msg = wrap.querySelector('[data-add-message]');
    if (!msg) return;
    msg.textContent = text;
    msg.hidden = false;
    msg.classList.toggle('complementary-product__add-message--error', !!isError);
  }

  function track(name, data) {
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      try {
        window.Shopify.analytics.publish(name, data || {});
      } catch (e) { /* analytics is best-effort */ }
    }
  }

  // Records where an item came from as a cart attribute, which carries onto
  // the order (admin only, never shown to customers). Best effort.
  function rrTagOrderSource(source, variantIds) {
    try {
      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var log = cart.attributes && cart.attributes.rr_upsell_log ? String(cart.attributes.rr_upsell_log).split(';') : [];
          variantIds.forEach(function (id) {
            var entry = source + ':' + id;
            if (log.indexOf(entry) === -1) log.push(entry);
          });
          while (log.join(';').length > 240) log.shift();
          return fetch('/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { rr_upsell_log: log.join(';') } })
          });
        })
        .catch(function () { /* never let tagging affect the basket */ });
    } catch (e) { /* ignore */ }
  }

  function cardProductId(el) {
    var card = closest(el, '[data-rr-pairs-card]');
    return card ? card.getAttribute('data-product-id') : null;
  }

  // Impression tracking: fires once per panel the first time it actually
  // scrolls into view, not on page load - a "Pairs well with" block near
  // the bottom of a long page is often never seen at all.
  function watchView(root) {
    if (root.dataset.viewTracked === 'true' || !root.querySelector('[data-rr-pairs-card]')) return;
    var sourceProductId = root.getAttribute('data-source-product-id');

    if (!('IntersectionObserver' in window)) {
      track('complementary_product_viewed', { sourceProductId: sourceProductId });
      root.dataset.viewTracked = 'true';
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && root.dataset.viewTracked !== 'true') {
          root.dataset.viewTracked = 'true';
          track('complementary_product_viewed', { sourceProductId: sourceProductId });
          observer.disconnect();
        }
      });
    }, { threshold: 0.25 });
    observer.observe(root);
  }


  // Load the recommendations: Shopify renders this section again with the
  // product's complementary products, and the filled box replaces the empty one.
  function loadPairs(root) {
    var section = closest(root, '.shopify-section');
    var sectionId = section && section.id ? section.id.replace(/^shopify-section-/, '') : '';
    var productId = root.getAttribute('data-rr-pairs');
    if (!sectionId || !productId) return;
    var base = (window.Theme && Theme.routes && Theme.routes.product_recommendations_url) || '/recommendations/products';
    var url = base + '?section_id=' + encodeURIComponent(sectionId) + '&product_id=' + encodeURIComponent(productId) +
      '&limit=' + encodeURIComponent(root.getAttribute('data-rr-pairs-limit') || '5') + '&intent=complementary';
    fetch(url, { credentials: 'same-origin' })
      .then(function (res) { return res.ok ? res.text() : ''; })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var filled = doc.querySelector('[data-rr-pairs="' + productId + '"]');
        if (filled && filled.innerHTML.trim()) {
          root.innerHTML = filled.innerHTML;
          watchView(root);
        }
      })
      .catch(function () { /* the box just stays empty */ });
  }

  document.querySelectorAll('[data-rr-pairs]').forEach(loadPairs);

  document.addEventListener('click', function (e) {
    // "View details"/image/title link - looking, not buying. Tells Oliver
    // whether the panel catches attention even when it doesn't convert.
    var viewLink = closest(e.target, '.complementary-product__link, .complementary-product__image-link, .complementary-product__name-link');
    if (viewLink) {
      var root = closest(e.target, '[data-rr-pairs]');
      track('complementary_product_clicked', {
        sourceProductId: root ? root.getAttribute('data-source-product-id') : null,
        pairedProductId: cardProductId(e.target)
      });
      // no return - let the link navigate normally
    }

    var wrap = closest(e.target, '[data-quick-add]');
    if (!wrap) return;

    var stepBtn = closest(e.target, '[data-step]');
    if (stepBtn) {
      var qtyEl = wrap.querySelector('[data-qty]');
      var delta = parseInt(stepBtn.getAttribute('data-step'), 10) || 0;
      var qty = (parseInt(qtyEl.textContent, 10) || 1) + delta;
      if (qty < 1) qty = 1;
      var tracked = wrap.getAttribute('data-stock-tracked') === 'true';
      var stockQty = parseInt(wrap.getAttribute('data-stock-qty'), 10) || 0;
      if (tracked && stockQty > 0 && qty > stockQty) qty = stockQty;
      qtyEl.textContent = qty;
      return;
    }

    var addBtn = closest(e.target, '[data-add-btn]');
    if (addBtn) {
      var variantId = wrap.getAttribute('data-variant-id');
      var qty2 = parseInt(wrap.querySelector('[data-qty]').textContent, 10) || 1;
      var addRoot = closest(e.target, '[data-rr-pairs]');
      var sourceProductIdForAdd = addRoot ? addRoot.getAttribute('data-source-product-id') : null;
      var pairedProductIdForAdd = cardProductId(e.target);
      addBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: qty2 }] })
      })
        .then(function (res) {
          if (res.ok) return res.json();
          return res.json().catch(function () { return {}; }).then(function (body) {
            throw new Error(body.description || body.message || 'Could not add to basket.');
          });
        })
        .then(function () {
          showMessage(wrap, 'Added', false);
          rrTagOrderSource(closest(addBtn, '[data-rr-xmas-pick]') ? 'xmas_pairs' : 'pairs_well_with', [variantId]);
          track('complementary_product_add_to_cart', {
            sourceProductId: sourceProductIdForAdd,
            pairedProductId: pairedProductIdForAdd,
            variantId: variantId,
            quantity: qty2
          });
          return fetch('/cart.js', { credentials: 'same-origin' })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (cart) {
              if (cart && typeof cart.item_count !== 'undefined') updateHeaderCount(cart.item_count);
            })
            .catch(function () { /* header count is cosmetic */ });
        })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        })
        .catch(function (err) {
          showMessage(wrap, (err && err.message) || 'Could not add to basket.', true);
        })
        .finally(function () {
          addBtn.disabled = false;
        });
    }
  });
}());
